export default __webpack_public_path__ + "static/media/rocket.4caba736.png";